// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"spinnerWrapper___BP6j7"};